import React from 'react';
import Amplify, {Auth} from 'aws-amplify';
import {SignIn} from "aws-amplify-react";
import {fetchSession, moveToECCWithCookie} from "../Logics/session";
import {SignInComponent} from "../Components/SignInComponent";
import TranslateError from "../translate/TranslateError";
import {err_logger} from "../Logics/logger";
import * as qs from "qs";
import {resend_verify_code_for_user_attributes} from "../Logics/cognito_process";
import APP_ENV from "../Environment";
import {requestAffiliateAgreements} from "../Logics/affiliate";

export default class MySignIn extends SignIn {
    constructor(props) {
        super(props);

        this.checkContact = this.checkContact.bind(this);
        this.signIn = this.signIn.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleAffiliateRequest = this.handleAffiliateRequest.bind(this);
        this.handleInputAffiliateChange = this.handleInputAffiliateChange.bind(this);

        this._validAuthStates = ['signIn', 'signedOut', 'signedUp', 'oauthSignIn'];
        this.state = {
            display_screen: true,
            execute_display_check: false,
            setRefresh: false,
            blocking: false,
            keepInView: false,
            open_input: false,
            cookies: {},
            agreement1: false,
            agreement2: false,
            agreeBtnDisabled: true,
            re_announce_affiliate: false,
            mode: "",
        };
    }

    componentDidUpdate(prevProps) {
        const params = qs.parse(window.location.search.substr(1));
        const mode = params["mode"];
        if (!this.state.mode && mode === "wgs") {
            this.setState({mode: "wgs"});
        }
        if (mode == "wgs") {
            document.cookie = `mode=wgs; Max-Age=3600; domain=.genelife.jp; path=/`;
        }

        if (this.props.authState  && this.props.authState === 'oauthSignIn' && !this.state.execute_display_check) {
            this.setState({display_screen: false, execute_display_check: true})

        } else if (this.props.authData && this.props.authData.display_screen && this.state.execute_display_check) {
            this.setState({display_screen: true, execute_display_check: false})
        }
    }


    checkContact(user) {
        if (!Auth || typeof Auth.verifiedContact !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.verifiedContact(user)
            .then(data => {
                if (!data.verified) {
                    // ↓ update library
                    fetchSession().then(() => {}).catch(e => console.log(e));
                    // ↑ update library
                } else {
                    user = Object.assign(user, data);
                    this.changeState('verifyContact', user);
                }
            });
    }

    async signIn() {
        if (!this.inputs.username ||  !this.inputs.password) {
            this.display_err("未入力の項目があります");
            return;
        }
        const username = this.inputs.username.trim().toLowerCase();
        const password = this.inputs.password.trim();
        if (!Auth || typeof Auth.signIn !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        this.setState({blocking: true, keepInView: true})
        window.scrollTo(window.scrollX, window.scrollY + 1);
        try {
            let user = await Amplify.Auth.signIn(username, password);
            // ↓ update library
            // CognitoユーザのステータスがConfirmの場合はchallengeNameがないので、セッション取得処理に入る
            if (!user.challengeName && !this.state.setRefresh) {
                // 通常ログイン遷移した場合のトークンリフレッシュ処理(最新のユーザ情報を取得)
                const { refreshToken } = user.getSignInUserSession();
                if (refreshToken) {
                    this.setState({setRefresh: true})
                    await user.refreshSession(refreshToken, async (err, session) => {
                        if (session) {
                            let refresh_user = session.idToken.payload;
                            await this.setSession(user, refresh_user);
                        } else {
                            await this.setSession(user);
                        }
                    });
                } else {
                    await this.setSession(user);
                }
                // ↑ update library
            } else if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                this.setState({blocking: false, keepInView: false})
                this.changeState('confirmSignIn', user);
            } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                // ↓ update library
                const params = qs.parse(window.location.search.substr(1));
                const {disp_new_password} = params;
                this.setState({blocking: false, keepInView: false})
                if (disp_new_password) {
                    this.changeState('requireNewPassword', user);
                } else {
                    // パスワード変更以来のメッセージ画面へ遷移させる
                    this.changeState('NewPassSendMessage', user);
                }
                // ↑ update library
            } else if (user.challengeName === 'MFA_SETUP') {
                this.changeState('TOTPSetup', user);
            } else {
                this.checkContact(user);
            }
        } catch (err) {
            if (err.name != null) {
                // eslint-disable-next-line no-ex-assign
                err = TranslateError(err);
                if (err.code === 'UserNotConfirmedException') {
                    this.setState({blocking: false, keepInView: false})
                    window.history.replaceState('','','/confirm_sign_up');
                    this.changeState('confirmSignUp', {username, password, isInitialMessage: true});
                } else if (err.code === 'PasswordResetRequiredException') {
                    // ↓ update library
                    // 手動でコード生成メールを送信
                    Auth.forgotPassword(username)
                        .then(data => {
                            window.history.replaceState('','','/change_password');
                            this.setState({blocking: false, keepInView: false})
                            this.changeState('forgotPassword', {username});
                            this.error("認証コードを送信しました")
                        })
                        .catch(err => {
                            err_logger(username, err, "forgotPassword in signIn",{username});
                            this.display_err(err, true)
                        });
                    // ↑ update library
                } else if (err.code === 'UserLambdaValidationException'){
                    this.display_err("新しいメールアドレスの認証が完了していません。認証コードが届いていない場合は、当社までお問い合わせください。");
                    err_logger(username, err, "email_verified false signIn", {username});
                } else {
                    this.display_err("入力内容に誤りがあります。ご確認の上、再度ご入力をお願い致します。");
                    err_logger(username, err, "signIn",{username});
                }
            } else {
                err_logger(username, err, "signIn other",{username});
                this.display_err("通信エラーです");
            }

        }
    }

    display_err(err, translate = false) {
        window.scrollTo(0, 0);
        this.setState({blocking: false, keepInView: false})
        if (translate) {
            this.error(TranslateError(err))
        } else {
            this.error(err);
        }
    }

    async setSession(user, refresh_user = null) {
        if (refresh_user) {
            Object.assign(user.attributes, refresh_user);
        }
        this.setState({setRefresh: false})

        if (user.attributes.email_verified === false) {
            const email = user.attributes.email;
            try {
                await resend_verify_code_for_user_attributes(user);
                window.history.replaceState('', '', '/confirm_change_email');
                this.changeState('ConfirmChangeEmail', {user, email, isSendChangeEmail: true});

            } catch (e) {
                this.display_err("新しいメールアドレスの認証が完了していません。認証コードが届いていない場合は、当社までお問い合わせください。");
                err_logger(email, e, "signIn resend verify code for change email",{sub: user.attributes.sub});

            }finally {
                this.setState({blocking: false, keepInView: false})
            }
        } else {
            fetchSession()
                .then((res) => {
                    if (APP_ENV.AFFILIATE_RECOMMEND) {
                        this.request_affiliate_agree(res);
                    } else {
                        this.setState({cookies: res});
                        this.requestECCMypage();
                    }
                })
                .catch(e => {
                    err_logger(user.attributes.email, e, "signIn other",{email: user.attributes.email});
                    this.display_err("ログインに失敗しました");
                });
        }
    }

    requestECCMypage() {
        let gene = this.state.cookies.gene;
        const finishState = () => {
            this.setState({blocking: false, keepInView: false})
        };
        setTimeout(finishState, 30000);
        this.setState({open_input: false, cookies: {}});
        console.log("ecc");
        console.log(this.state.mode);

        moveToECCWithCookie(gene);
    }

    handleClose() {
        let affiliate_method = 'post';
        let process = 'later';
        requestAffiliateAgreements(affiliate_method, process).then((affiliate_res) => {
        }).catch(e => console.log(e))
            .finally(()=> this.requestECCMypage());
    }

    handleAffiliateRequest() {
        let affiliate_method = 'post';
        let process = null;
        if (this.state.re_announce_affiliate) {
            affiliate_method = 'put';
            process = 'later';
        }
        requestAffiliateAgreements(affiliate_method, process).then((affiliate_res) => {
        }).catch(e => console.log(e))
          .finally(()=> this.requestECCMypage());
    }

    handleInputAffiliateChange(e) {
        let agreement1 = e.target.name === 'agreement1' ? e.target.checked : this.state.agreement1;
        let agreement2 = e.target.name === 'agreement2' ? e.target.checked : this.state.agreement2;
        this.setState({
            [e.target.name] : e.target.checked
        });
        if (agreement1 && agreement2) {
            this.setState({
                agreeBtnDisabled : false
            });
        } else {
            this.setState({
                agreeBtnDisabled : true
            });

        }
    }

    request_affiliate_agree (res) {
        requestAffiliateAgreements('get').then((affiliate) => {
            if (affiliate.res.status === 204) {
                this.setState({open_input: true, cookies: res})
            } else {
                if (affiliate.res.body.agreed_at) {
                    this.setState({cookies: res});
                    this.requestECCMypage();

                } else if (affiliate.res.body.suspended_at) {
                    if (affiliate.res.body.status === 'expiration') {
                        this.setState({open_input: true, cookies: res, re_announce_affiliate: true})

                    } else {
                        this.setState({cookies: res});
                        this.requestECCMypage();

                    }
                }
            }
        }).catch(e => {
            // セッションは出来ているからログインさせる
            this.setState({cookies: res});
            this.requestECCMypage();
        });
    };

    showComponent(theme) {
        // ↓ update library
        let component = null;
        if (this.state.display_screen) {
            component =
            <SignInComponent theme={theme} authState={this.state.authState} mySignIn={this}
                             changeStateForgotPassFunc={() => {
                                window.history.replaceState('', '', '/forget_password');
                                this.changeState('forgotPassword')}
                             }
                             signIn={this.signIn} loading={this.state.loading}
                             openInput={this.state.open_input} handleClose={this.handleClose}
                             handleAffiliateRequest={this.handleAffiliateRequest}
                             changeStateSignInFunc={() => {
                                if (this.state.mode == "wgs") {
                                    window.location = '/sign_up?mode=wgs';
                                } else {
                                    window.history.replaceState('', '', '/sign_up');
                                    this.changeState('signUp')
                                }}
                             }
                             changeStateEccAcountChkInFunc={() => {
                                window.history.replaceState('', '', '/check_account');
                                this.changeState('checkEccAccount')}
                             }
                             changeStateSignOutFunc={() => this.changeState('signOut')}
                             blocking={this.state.blocking} keepInView={this.state.keepInView}
                             handleInputAffiliateChange={this.handleInputAffiliateChange}
                             agreement1={this.state.agreement1} agreement2={this.state.agreement2}
                             agreeBtnDisabled={this.state.agreeBtnDisabled}
            />

        }
        return component;
        // ↑ update library
    }
}